import { FacilityStatus } from '@umss/shared/data-access';
import { BaseEntityDto } from '../common/base-entity.dto';
import { LocationDto } from '../common/location.dto';

export interface FacilityForAdminDto extends BaseEntityDto {
  name: string;
  facilityTypeId?: number | null;
  facilityTypeName?: string | null;
  contactEmail: string;
  contactPhone: string;
  location: LocationDto;
  status: FacilityStatus;
  registeredDate: string; // DateTime as ISO string
  activeShiftsCount: number;
  totalAmountOwed: number;
  overdueInvoicesCount: number;
  lastInvoiceDate?: string | null; // DateTime as ISO string
}
